export interface NewUser {
  username: string;
  password: string;
  firstName?: string;
  lastName?: string;
  email: string;
  languageCode: string;
}
